<template>
  <v-container fluid grid-list-sm>
    <v-toolbar dense>
      <v-toolbar-title>{{ currentStandard.name }} - {{ currentStandard.description }}</v-toolbar-title>
    </v-toolbar>
    <v-card>
      <v-list two-line subheader>
        <v-list-tile v-for="chapter in currentStandard.chapters" :key="chapter.id">
          <v-list-tile-content>{{ chapter.id }}</v-list-tile-content>

          <v-list-tile-content>
            <v-list-tile-title>{{ chapter.description }}</v-list-tile-title>
          </v-list-tile-content>

          <v-list-tile-action>
            <v-btn icon ripple>
              <v-icon color="grey lighten-1">info</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { api } from "@/store/modules/standards";

export default {
  props: {
    standardId: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters(api.namespace, [api.getters.getStandard]),
    currentStandard() {
      console.log(this.standardId);
      return this.getStandard(this.standardId);
    }
  }
};
</script>
